export const stringToNumber = (value) => parseInt(value.replace(/\./g, ""), 10);
